var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{},[_c('div',{staticClass:"usp"},[_c('p',[_c('checkmark'),_c('br'),_vm._t("default")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }